import React from 'react'

import {
  PrimaryParagraph,
  SecondaryHeading,
  SubsectionTitle,
} from 'Components/Blocks'
import { Column, Row } from 'Components/UI'

import { TaskAltSvg } from 'Assets/Svg'

import { LANDING_CONTENT_PX, LANDING_SECTION_PY } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { EMAJIN_SECTION_QUESTION_ITEMS } from './constants'
import ImageContainer from './ImageContainer'
import { Container, Content } from './styles'

function ExecutiveInviteQuestionSectionQuestions() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  const isNotDesktop = !isWideDesktop && !isDesktop

  return (
    <Container pb={LANDING_SECTION_PY} pt={[0, 0, 0, 17, 19]}>
      <Column px={LANDING_CONTENT_PX}>
        {EMAJIN_SECTION_QUESTION_ITEMS.map((item, index) => (
          <Content
            flexDirection={[
              'column',
              'column',
              'column',
              'column',
              index % 2 === 0 ? 'row' : 'row-reverse',
            ]}
            gap={[0, 0, 0, 13]}
            key={item.id}
          >
            <ImageContainer item={item} />

            <Column
              alignCenter={isNotDesktop}
              alignStart={!isNotDesktop}
              maxWidth={isNotDesktop ? 420 : 'unset'}
              width={[1, 1, 1, 1, 1 / 2]}
            >
              <SubsectionTitle
                centered={isNotDesktop}
                paragraph={item.plainText}
                subtitle={item.subtitle}
                title={item.title}
              />

              <SecondaryHeading
                centered={isNotDesktop}
                mb={7}
                mt={15}
                text={item.subtitle2}
              />

              <Column gap={5}>
                {item.benefits.map(benefit => (
                  <Row fullWidth gap={4} key={benefit.id}>
                    <Row mt={1}>
                      <TaskAltSvg />
                    </Row>

                    <PrimaryParagraph text={benefit.text} />
                  </Row>
                ))}
              </Column>
            </Column>
          </Content>
        ))}
      </Column>
    </Container>
  )
}

export default ExecutiveInviteQuestionSectionQuestions
